import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const CategoriesSC = styled.div`
    display: flex;
    flex-direction: column;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
    padding-top: 76px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 80%;

    .grid-title {
        font-size: 32px;
        font-weight: 500;
        margin-bottom: 48px;
        letter-spacing: 1px;
        width: 100%;
        text-align: center;
    }

    .category-holder {
        display: grid;
        grid-template-columns: repeat(3, minmax(260px, 1fr));
        gap: 28px;
        width: 100%;
        ${NoTextSelectionStyles}
    }

   .category-card {
        background: #ffffff;
        border-radius: 16px;
        padding: 22px 22px 26px;
        box-shadow:
            0 12px 30px rgba(0, 0, 0, 0.05);
        position: relative;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }


    /* Icon */
    .category-icon {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        background: #f2f5ff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 14px;
    }

    .category-emoji {
        font-size: 18px;
        margin-bottom: 12px;
        width: 48px;
        height: 48px;
        border-radius: 24px;
        background: #f2f5ff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Title */
    .category-title {
        font-size: 18px;
        font-weight: 600;
        color: #1f2a44;
        letter-spacing: 0.75px;
        margin: 0 0 8px;
    }

    /* Description */
    .category-description {
        font-size: 16px;
        line-height: 1.6;
        color: #6b7280;
        margin: 0;
        max-width: 340px;
    }

    /* Arrow */
    .category-arrow {
        position: absolute;
        bottom: 18px;
        right: 20px;
        font-size: 18px;
        color: #4f46e5;
    }

    @media (max-width: 768px) {
        .grid-title {
            font-size: 18px;
            margin-bottom: 24px;
            letter-spacing: 1px;
        }

        .category-holder {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .category-card {
            border-radius: 8px;
            padding: 12px 12px 16px;
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08);
        }

        .category-emoji {
            font-size: 18px;
            margin-bottom: 12px;
            width: 36px;
            height: 36px;
            border-radius: 18px;
        }

        .category-title {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0.75px;
        }

        .category-description {
            font-size: 12px;
            line-height: 1.4;
            max-width: 400px;
        }
    }
`

export default CategoriesSC;